import { Card, CardBody, Flex, Icon, Image, Text } from '@chakra-ui/react';
import { PropertyDetailsFragment } from '@client/graphql/__generated__/types';
import { formatToCurrency } from '@common/utils/formatter';
import { BathIcon, BedSingleIcon } from 'lucide-react';
import { useNavigate } from 'react-router';
import { DEFAULT_PROPERTY_IMAGE_URL } from '~/apps/consumer/utils/listing.utils';
import { getOffMarketListingPath } from '~/apps/consumer/utils/routes.utils';

export const HorizontalPropertyDetailsCard = ({
  propertyDetails,
}: {
  propertyDetails: PropertyDetailsFragment;
}) => {
  const navigate = useNavigate();

  const navigateToOffMarketListing = () => {
    navigate(getOffMarketListingPath(propertyDetails.id));
  };

  return (
    <Card cursor="pointer" onClick={navigateToOffMarketListing}>
      <CardBody p={3}>
        <Flex alignItems="center" gap={2}>
          <Image height="100%" src={DEFAULT_PROPERTY_IMAGE_URL} width="100px" />
          <Flex direction="column" gap={1}>
            <Flex direction="column" gap={0}>
              <Text fontWeight="medium" lineHeight="1.2">
                {propertyDetails.streetAddress} {propertyDetails.unit}{' '}
              </Text>
              <Text fontWeight="medium" lineHeight="1.2">
                {propertyDetails.city}, {propertyDetails.state}{' '}
                {propertyDetails.zipCode}
              </Text>
            </Flex>

            <Flex alignItems="center" gap={2}>
              <Text color="whiteAlpha.600">
                {formatToCurrency(propertyDetails.targetPrice)}
              </Text>
              <Flex alignItems="center" gap={0.5}>
                <Icon as={BedSingleIcon} color="whiteAlpha.600" />
                <Text color="whiteAlpha.600" fontSize="sm">
                  {propertyDetails.bedrooms}
                </Text>
              </Flex>
              <Flex alignItems="center" gap={0.5}>
                <Icon as={BathIcon} color="whiteAlpha.600" />
                <Text color="whiteAlpha.600" fontSize="sm">
                  {(propertyDetails.bathsFull || 0) +
                    (propertyDetails.bathsHalf || 0)}
                </Text>
              </Flex>
              <Text color="whiteAlpha.600" fontSize="sm">
                {propertyDetails.areaSqFt} sq<sup>ft</sup>
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </CardBody>
    </Card>
  );
};
